import { CompareOrder } from './CompareOrder';

export function compareUndefined(
	a: unknown,
	b: unknown,
	handleUndefined: CompareOrder = CompareOrder.Equal,
): CompareOrder {
	// Values are the same
	if (a === b) {
		return CompareOrder.Equal;
	}

	const undefinedA = a === undefined;
	const undefinedB = b === undefined;

	// Neither value is undefined
	if (!undefinedA && !undefinedB) {
		return CompareOrder.Equal;
	}

	// Return how we want the undefined value to be handled if the first value is undefined
	if (undefinedA) {
		return handleUndefined;
	}

	// Otherwise return the opposite
	return handleUndefined * -1;
}
